import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const forgot = async (e) => {
    e.preventDefault();
    setForgotMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setForgotMsg(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Logo />
          <p className="text-sub text-sm mt-3">Masuk sebagai pemilik situs untuk mengelola konten.</p>
        </div>
        <form onSubmit={submit} className="bg-surface border border-line rounded-xl p-7 space-y-4">
          <div>
            <label htmlFor="admin-email" className="field-label">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field-input" placeholder="email pemilik" />
          </div>
          <div>
            <label htmlFor="admin-password" className="field-label">Kata sandi</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field-input" placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" role="alert" className="text-sm text-enji">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full">
            {loading && <Loader2 size={16} className="animate-spin" />}
            Masuk
          </button>
          <button type="button" data-testid="admin-forgot-toggle" onClick={forgot} className="text-[13px] text-sub underline underline-offset-2 hover:text-enji w-full">
            Lupa kata sandi?
          </button>
          {forgotMsg && <p data-testid="admin-forgot-message" className="text-[13px] text-moss bg-moss/10 rounded-lg p-3">{forgotMsg}</p>}
        </form>
        <p className="text-[12px] text-faint text-center mt-6">Hanya pemilik situs yang memiliki akses.</p>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const navigate = useNavigate();
  const [token] = useState(() => new URLSearchParams(window.location.search).get("token") || "");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setMsg("Kata sandi diperbarui. Silakan login dengan kata sandi baru.");
      setTimeout(() => navigate("/admin"), 1500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-surface border border-line rounded-xl p-7 space-y-4">
        <h1 className="font-serif text-2xl text-ink">Atur Ulang Kata Sandi</h1>
        <input type="password" data-testid="reset-password-input" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="field-input" placeholder="Kata sandi baru (min. 8 karakter)" />
        {error && <p role="alert" className="text-sm text-enji">{error}</p>}
        {msg && <p className="text-sm text-moss">{msg}</p>}
        <button type="submit" data-testid="reset-password-submit" disabled={loading} className="btn-primary w-full">
          {loading && <Loader2 size={16} className="animate-spin" />}
          Simpan Kata Sandi
        </button>
      </form>
    </div>
  );
}

